module.exports = __webpack_public_path__ + "img/note.4fef11b2.svg";